import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M7.15 11.06v.69A2.25 2.25 0 0 1 4.9 14h-.69A2.25 2.25 0 0 1 2 11.75v-.69a2.25 2.25 0 0 1 2.21-2.25h.69a2.25 2.25 0 0 1 2.25 2.25Zm4.65-2.25h-.69a2.25 2.25 0 0 0-2.25 2.25v.69A2.25 2.25 0 0 0 11.11 14h.69a2.25 2.25 0 0 0 2.25-2.25v-.69a2.25 2.25 0 0 0-2.25-2.25Zm0-6.8h-.69a2.25 2.25 0 0 0-2.25 2.25V5a2.25 2.25 0 0 0 2.25 2.2h.69A2.25 2.25 0 0 0 14.05 5v-.74A2.25 2.25 0 0 0 11.8 2ZM4.9 2h-.69A2.25 2.25 0 0 0 2 4.26V5a2.25 2.25 0 0 0 2.21 2.2h.69A2.25 2.25 0 0 0 7.15 5v-.74A2.25 2.25 0 0 0 4.9 2Z';
const draw24px =
  'M8,10.75H5A2.75,2.75,0,0,1,2.27,8V5A2.76,2.76,0,0,1,5,2.27H8A2.76,2.76,0,0,1,10.75,5V8A2.75,2.75,0,0,1,8,10.75Zm11,0H16A2.75,2.75,0,0,1,13.25,8V5A2.75,2.75,0,0,1,16,2.27h3A2.76,2.76,0,0,1,21.73,5V8A2.75,2.75,0,0,1,19,10.75Zm-11,11H5A2.76,2.76,0,0,1,2.27,19V16A2.75,2.75,0,0,1,5,13.25H8A2.75,2.75,0,0,1,10.75,16v3A2.76,2.76,0,0,1,8,21.73Zm11,0H16A2.75,2.75,0,0,1,13.25,19V16A2.75,2.75,0,0,1,16,13.25h3A2.75,2.75,0,0,1,21.73,16v3A2.76,2.76,0,0,1,19,21.73Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const GridFilledIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'gridFilled'),
) as IconWithRender;

GridFilledIcon.displayName = 'GridFilledIcon';
GridFilledIcon.propTypes = Icon.propTypes;
GridFilledIcon.renderIcon = (props) => <GridFilledIcon {...props} />;
export default GridFilledIcon;
